import { Component  } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';


import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { OpcionModel } from '../Global/Opcion.model';
import { ResolucionModel } from './Resolucion.model';

@Component({
	selector : 'ResolucionIndex',
	templateUrl : './ResolucionIndex.component.html',
	styleUrls  : ['../../../../styles.css']

})

export class ResolucionIndexComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public displayedColumns;
	public dataSource;
	

	myControl = new FormControl();
	public form: FormGroup;
	public formErrors: any;


	cnumcontControl = new FormControl();
	ciddocControl = new FormControl();
	public ciddoc:string = "";
	public cnumcont:OpcionModel = new OpcionModel("", "");
	public cprefijo:string = "";
	private resoluciones:Array<ResolucionModel> = new Array();
	public listaNegocios:Array<OpcionModel>;
	public listaPrefijos:Array<string>;
	cnumcontOptions: Observable<OpcionModel[]>;

	public ocultar: boolean = false;
	public mensaje: string = "";

	constructor(private _serviciosGenerales:ServiciosGenerales,
		public snackBar: MatSnackBar,
		private _router:Router,
		private _route: ActivatedRoute, private formBuilder: FormBuilder){

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();

		this._route.params.subscribe( params =>{
			this.cnumcont =  new OpcionModel(params['cnumcont'], "");
			this.cprefijo = params['cprefijo'];
			this.ciddoc = this.cprefijo;
		});
		

		this.formErrors = {

			cnumcont : {},
			ciddoc : {}
			
		};

	}


	ngOnInit(){
		//NIDREG	CNUMCONT	CPREFIJO	VRESOLUCION	NDESDE	NHASTA	NMESESRESOLUCION	DFECHAEXPEDICION	DFECHAVENCIMIENTO	NESTADO	BLOQUEAR
		
		this.displayedColumns = ['cnumcont', 'cprefijo', 'vresolucion', 'ndesde', 'nhasta', 'nmesesresolucion','dfechaexpedi', 'dfechavencimiento', 'nestado'];
		this.dataSource = new ExampleDataSource(null);	
		this.listaPrefijos = new Array();
		this.listaNegocios = Array();

		

		this._serviciosGenerales.get('listaNegocios', {}).subscribe(
			
			result=>{
				
				

				for(let x in result)
					this.listaNegocios.push(new OpcionModel(result[x].cnumcont.trim(), result[x].vnombrenegocio.trim()));
				

				this.cnumcontOptions = this.cnumcontControl.valueChanges
				.startWith(null)
				.map(val => val ? this.filtro(val) : this.listaNegocios.slice());



				this._route.params.subscribe(params=>{
					
					if( !!params["cnumcont"]){
						for(let x in result)
							if(result[x].cnumcont.trim() == params["cnumcont"].trim())
								this.cnumcont.labelOpcion = result[x].cnumcont.trim()+' - '+result[x].vnombrenegocio.trim();
							
							this.eventoConsulta(params["cprefijo"]);
							
						}

					})

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la lista de negocios", "X");
			});

		
		this.listaPrefijos.push("");


		this.form = this.formBuilder.group({
			cnumcont   : [
			{
				value   : this.cnumcont.labelOpcion,
				disabled: false
			}],
			ciddoc   : [
			{
				value   : this.ciddoc,
				disabled: false
			}]
		});

		this.consultarResoluciones();

	}


	consultarResoluciones(){

		this.resoluciones = new Array();
		
		this._serviciosGenerales.get('consultarResolucionesPorContratoyPrefijo', {cnumcont : this.cnumcont.idOpcion, cprefijo : this.cprefijo}).subscribe(
			r=>{
				for(let x in r){
					this.resoluciones.push(new ResolucionModel(r[x].cnumcont, r[x].cprefijo, r[x].vresolucion, r[x].ndesde, r[x].nhasta, r[x].nmesesresolucion, r[x].dfechaexpedicion,  r[x].dfechavencimiento, r[x].nestado));
					console.log(r[x]);
				}
				
				console.log(this.resoluciones);
				this.dataSource = new ExampleDataSource(this.resoluciones);	

			}, error=>{
				this.openSnackBarEspecial("Ocurrió un error mientras se carga las resoluciones", "X");
				console.log(error, '');
			});
	}


	agregar(){
		if( this.cnumcont.idOpcion == undefined ||  this.cnumcont.idOpcion == null)
 			this.cnumcont.idOpcion = '';
 		if( this.cprefijo == undefined || this.cprefijo == null)
 			this.cprefijo = '';

 		if(this.cnumcont.idOpcion == ''){
 			this.openSnackBarEspecial("Hay que seleccionar un contrato", "X");
 			return;
 		}

 		if(this.cprefijo == ''){
 			this.openSnackBarEspecial("Hay que seleccionar un prefijo", "X");
 			return;
 		}
 		
		
		this._router.navigate(['/Resolucion/e/', this.cnumcont.idOpcion, this.cprefijo]);
	}

	filtro(val: string)//: string[]
	{

		if(val == null){
			val = "";
		}


		let x = this.listaNegocios.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 
		console.log(x);
		return x;

		
	}


	eventoConsulta(opcional){
		
		this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();
		this.listaPrefijos = new Array();
		
		this.dataSource = new ExampleDataSource(null);

		this.cprefijo = '';

		this._serviciosGenerales.get('listaPrefijos', {cnumcont : this.cnumcont.idOpcion}).subscribe(
			
			result=>{
				for(let x in result)
					this.listaPrefijos.push(result[x].cprefijo.trim());
				if(opcional!= null && opcional != ''){
					this.cprefijo = opcional;
					this.consultarResoluciones();
				}

				if(this.listaPrefijos.length == 0){
					this.openSnackBarEspecial("No se encontraron prefijos para el contrato : "+this.cnumcont.idOpcion, "X");
					return;
				}
				else
					this.snackBar.dismiss();


			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}


	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	onFormValuesChanged()
	{
		for ( const field in this.formErrors )
		{
			if ( !this.formErrors.hasOwnProperty(field) )
			{
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if ( control && control.dirty && !control.valid )
			{
				this.formErrors[field] = control.errors;
			}
		}
	}


	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}


export class ExampleDataSource {

	public data: Array<ResolucionModel>;
	

	constructor(tercero:Array<ResolucionModel>){
		this.data = new Array();
		
		
		if(tercero != null){
			for(let i of tercero){
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<ResolucionModel[]>
	{
		return Observable.of(this.data);
	}

	disconnect(){}
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Resoluciones/ResolucionIndex.component.ts